module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAEgAAABIBAMAAACnw650AAAAFVBMVEUAAAC+GTG+GTG+GTG+GTG+GTG+GTGgxwOeAAAAB3RSTlMAIJ/v/wAwF8MKgAAAAFpJREFUeAFjGGAgZOKsGIoGGND4YSYuLs6pBBQJuwCBIQFFKiBFTgQUmYAUORNQ5AIGQ1HRqKJRRaOKRhWNKkIU9pRXG4gKiPKqLJRApYgAg03RaG0+mp6wAwCaVBiKwg1ZCAAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/devfest/2757.png
// module id = 1407
// module chunks = 0